<template>
  <i18nLink
    v-if="attributes?.slug"
    :to="{ name: 'exhibitions-slug', params: { slug: attributes?.slug }, query }"
    :locale="i18nCode"
    :class="$style.root"
  >
    <slot />
  </i18nLink>
</template>

<script lang="ts" setup>
const props = defineProps({
  data: Object
})

const localizedData = baseStrapiGetLocalizedData(props.data)

const getAttributes = baseStrapiGetAttributes
const attributes = baseStrapiGetAttributes(localizedData)
const i18nCode = baseI18nGetCodeForIso(attributes?.locale)

const route = useRoute()
const slugMatchesEventsSlugPage = computed(() => {
  return attributes?.slug === route?.params?.slug
})

const query = computed(() => filterRouteQuery(route?.query))
</script>

<style module>
.root {
  composes: reset-link from global;
}

.root:global(.router-link-exact-active) {
  color: var(--color--background);
  background-color: var(--color--primary);
  border-color: var(--color--primary);
}
</style>
